export default "__VITE_ASSET__lUbmgF1z__"